import EventInfiniteList from './EventInfiniteList';
export default EventInfiniteList;
